import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import Client from './Client';
import Chart from './Chart';
import Dashboard from './Dashboard';
import Unit from './Unit';
import UnitGroup from './UnitGroup';
import UnitSensor from './UnitSensor';
import Layout from './Layout';
import Home from './Home';
import SensorType from './SensorType';

import Settings from './Account/Settings';
import Logout from './Account/Logout';
import Login from './Account/Login';
import Confirm from './Account/Confirm';
import Register from './Account/Register';

export interface RouteData {
    paths: string[];
    component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
}

const RoutingData: any = [
    {
        component: Home,
        paths: ['/Home', '/home']
    },
    {
        component: Dashboard,
        paths: ['/Dashboard', '/dashboard']
    },
    {
        component: UnitGroup,
        paths: ['/UnitGroup', '/unitgroup']
    },
    {
        component: Client,
        paths: ['/Client', '/client']
    },
    {
        component: Unit,
        paths: ['/Unit', '/unit']
    },
    {
        component: SensorType,
        paths: ['/SensorType', '/sensortype']
    },
    {
        component: Settings,
        paths: ['/Settings', '/settings']
    },
    {
        component: UnitSensor,
        paths: ['/UnitSensor', '/unitsensor']
    },
    {
        component: Logout,
        paths: ['/Logout', '/logout']
    },
    {
        component: Login,
        paths: ['/Login', '/login']
    },
    {
        component: Confirm,
        paths: ['/Confirm', '/confirm']
    },
    {
        component: Register,
        paths: ['/Register', '/register']
    },
    {
        component: Chart,
        paths: ['/Chart', '/chart']
    }
];

export default { Home, Layout, RoutingData };


// WEBPACK FOOTER //
// ./src/container/index.ts